<template>
  <div>
    <b><span>Resumo:</span></b>
    <br>
    <div>
      <div>
        <span v-show="ExisteAnalise(resumo.situacaoDataBusca)">           <strong>Análise cadastral detalhada:</strong> {{ ObterDescricao(resumo.situacaoDataBusca) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoDataBusca)">           <strong>Comparativo de dados:</strong> {{ ObterDescricaoComparativo(comparativo) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoObitoFiscal)">         <strong>Óbito e fiscal:</strong> {{ ObterDescricao(resumo.situacaoObitoFiscal) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoCadastroRestritivo)">  <strong>Cadastro restritivo:</strong> {{ ObterDescricao(resumo.situacaoCadastroRestritivo) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoMidiaDesabonadora)">   <strong>Mídia desabonadora:</strong> {{ ObterDescricao(resumo.situacaoMidiaDesabonadora) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoEmailAge)">            <strong>E-mail age:</strong> {{ ObterDescricao(resumo.situacaoEmailAge) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoCriminalResumo)">      <strong>Análise restritiva:</strong> {{ ObterDescricao(resumo.situacaoCriminalResumo) }} <br></span>    
        <span v-show="ExisteAnalise(resumo.situacaoCriminalDetalhe)">     <strong>Criminal detalhe:</strong> {{ ObterDescricao(resumo.situacaoCriminalDetalhe) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoQuodRufra)">           <strong>Indício de fraude:</strong> {{ ObterDescricao(resumo.situacaoQuodRufra) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoSerproReceita)">       <strong>Análise cadastral simplificada:</strong> {{ ObterDescricao(resumo.situacaoSerproReceita) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoDictMed)">             <strong>AntiFraude:</strong> {{ ObterDescricao(resumo.situacaoDictMed) }} <br></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onboarding: Object,
    comparativoDados: Array
  },
  data() {
    return {
      resumo: {},
      comparativo: {},
      bureausConsultados: 0
    }
  },
  methods: {
    alimentarObjeto() {
      let th = this
      Object.assign(th.resumo, th.onboarding)
      Object.assign(th.comparativo, th.comparativoDados)       
      th.refresh();
    },
    ObterDescricao(valor){
      let th = this
      if(valor) 
        return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == valor).text
      
      return "Validação não encontrada."  
    },
    ObterDescricaoComparativo(){
      let th = this
      if (Array.isArray(th.comparativoDados)) {
        const possuiRestricao = th.comparativoDados.some(item => item.comparativoBureau === 2);
        return possuiRestricao ? th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 3).text : th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 2).text;
      }
      
      return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 99).text;
    },
    ExisteAnalise(valor){
      if(valor) 
        return true 
    },
    refresh(){
      this.$forceUpdate();  
    }
  },
}
</script>
<style scoped>
</style>
